import BaseModel from './base';

export default class UserDuplicateMerge extends BaseModel {
  constructor(userDuplicateMerge) {
    super(userDuplicateMerge);

    this.id = userDuplicateMerge.id;
    this.email = userDuplicateMerge.email;
    this.is_confirmed = userDuplicateMerge.is_confirmed;
    this.owner_id = userDuplicateMerge.owner_id;
  }
}
